import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoopSessionService } from './session';

export const authGuard: CanActivateFn = async () => {
  const session = inject(LoopSessionService);
  const router = inject(Router);
  if (!session.isSignedIn()) {
    return router.createUrlTree(['/login']);
  }
  try {
    if (!session.context()) await session.hydrate();
  } catch {
    session.signOut();
    return router.createUrlTree(['/login']);
  }
  if (session.mustChangePassword()) {
    return router.createUrlTree(['/set-password']);
  }
  if (!session.hasLoopAccess()) {
    return router.createUrlTree(['/no-access']);
  }
  return true;
};

export const guestGuard: CanActivateFn = () => {
  const session = inject(LoopSessionService);
  const router = inject(Router);
  if (session.isSignedIn()) {
    if (session.mustChangePassword()) return router.createUrlTree(['/set-password']);
    return router.createUrlTree(['/overview']);
  }
  return true;
};

/** Allow only when signed in and password change is required. */
export const setPasswordGuard: CanActivateFn = async () => {
  const session = inject(LoopSessionService);
  const router = inject(Router);
  if (!session.isSignedIn()) {
    return router.createUrlTree(['/login']);
  }
  try {
    if (!session.context()) await session.hydrate();
  } catch {
    session.signOut();
    return router.createUrlTree(['/login']);
  }
  if (!session.mustChangePassword()) {
    return router.createUrlTree(['/overview']);
  }
  return true;
};
